import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { DealSyncPage } from "@/components/data-sources/data-sources-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/data-sync/deals",
  loader: async () => {
    const [
      dealSyncSettingsRes,
      dealSyncHistoryRes,
      dealsRes,
      mappingsRes,
      mappableColumnsRes,
      hubspotPropsRes,
    ] = await Promise.all([
      fetch("/api/settings/deal-sync"),
      fetch("/api/deals/sync-history"),
      fetch("/api/deals?pageSize=1"),
      fetch("/api/deals/mappings"),
      fetch("/api/deals/mappable-columns"),
      fetch("/api/deals/hubspot-properties"),
    ]);
    const syncSettings = dealSyncSettingsRes.ok ? await dealSyncSettingsRes.json() : null;
    const syncHistory = dealSyncHistoryRes.ok ? await dealSyncHistoryRes.json() : { results: [] };
    const dealsData = dealsRes.ok ? await dealsRes.json() : { total: 0 };
    const mappingsData = mappingsRes.ok ? await mappingsRes.json() : { mappings: [] };
    const mappableColumnsData = mappableColumnsRes.ok
      ? await mappableColumnsRes.json()
      : { columns: [] };
    const hubspotPropsData = hubspotPropsRes.ok ? await hubspotPropsRes.json() : { properties: [] };
    return {
      dealSyncSettings: syncSettings ?? {
        intervalMs: 3600000,
        lastSyncedAt: null,
        backfillCompletedAt: null,
        schedulerActive: false,
      },
      dealSyncHistory: syncHistory.results ?? [],
      totalLocalDeals: dealsData.total ?? 0,
      mappings: mappingsData.mappings ?? [],
      mappableColumns: mappableColumnsData.columns ?? [],
      hubspotProperties: hubspotPropsData.properties ?? [],
    };
  },
  component: DealSyncPageGuard,
});

function DealSyncPageGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  if ((session?.user as any)?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <DealSyncPage />;
}
